import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import cloneDeep from 'lodash/cloneDeep'
import compact from 'lodash/compact';
import {isAdult} from '../pages/TravelerDetails/Components/Traveler';
import fecha from 'fecha';
import { 
  checkPaymentsCallWithUniqueMmtId,
  showPageLoaderAction,
  hidePageLoaderAction,
  getReservationChoice,
  reviewStatus
 } from '@mmt/rails/src/pages/Review/RailsReviewActions';
import {addDays} from '@mmt/legacy-commons/Helpers/dateHelpers';
import PaymentModule from '@mmt/legacy-commons/Native/PaymentModule';
import {getRsChoiceByValue} from '../pages/Constants/ReservationChoiceType';
import {NO_RESERVATION_CHOICE_CODE, REVIEW_PAGE_TRACKING_KEY} from './RailsConstant';
import { getBerthType} from '../pages/Constants/Berth';
import {getMealObject} from '../pages/Constants/MealNew';
import {getGenderfromValue} from '../pages/Constants/Gender';
import {skywalkerSectorConnector} from '../Skywalker/connector';
import { _label } from '../vernacular/AppLanguage';
import { isIos, isMweb } from './device';
import { getRootTag } from '@mmt/legacy-commons/AppState/RootTagHolder';
import { trackTravellerSeatInfo } from '../railsAnalytics';
import { getMmtId } from '@mmt/rails/src/pages/PostPayment/PostPaymentUtils';
import { getIfCanShowBNPP, getSeatLockReviewVariants } from 'apps/rails/src/RailsAbConfig';
import { bookingCheckoutAPIForPaymentInfo } from 'apps/rails/src/Utils/RailsAPIRepository';

export const getPaymentFareDetails = (reviewResponse) => {
  const {
    couponValidationResponse: couponDetail,
    totalFare,
    travelInsuranceCharge,
    mmtServiceFee,
    irctcConvenienceFee,
    travelInsuranceServiceTax,
    gatewayCharge
  } = reviewResponse;
  const insurance = travelInsuranceServiceTax + travelInsuranceCharge;
  const fareDescRows = [
    {
      mainText: 'Ticket Charge',
      subText: null,
      amount: totalFare
    },
    {
      mainText: 'Agent Service Charge & GST',
      subText: null,
      amount: mmtServiceFee
    },
    {
      mainText: 'IRCTC Travel Insurance Premium',
      subText: null,
      amount: insurance
    },
    {
      mainText: 'IRCTC Convenience Fee (incl. of GST)',
      subText: null,
      amount: irctcConvenienceFee
    }
  ];
  let couponDetailsModified;
  if (couponDetail) {
    couponDetailsModified = {
      ...couponDetail,
      couponCategory: 1,
      couponType: couponDetail.discountType,
      amount: couponDetail.discount
    };
  }
  return {
    fareDescRows,
    couponDetail: couponDetailsModified
  };
};

export const openPayment = () => async (dispatch, getState) => {
  const {
    railsListing: {
       selectedTrainInfo, selectedQuota,
       applicableFoodTypes,
    },
    railsReview: {
      bookingReviewRequest: request,
      bookingReviewResponse,
      currentAvailabilityStatus,
      bnppShownOnReview,
      bnppResponse: bnppResponseOnReview,
    },
    railsTraveler: {
      selectedTravelers, travelers, classValue, selectedReservationChoice, selectedPickupStation, boardingStationList, confirmBookCheckbox,
      originStation, destinationStation, selectedBookingDate, isBnppOpted, railofy: { bnppResponse: bnppResponseTravelerPage },
    }
  } = getState();

  let response = cloneDeep(bookingReviewResponse);

  await checkPaymentsCallWithUniqueMmtId();
  let fromCityName = isEmpty(originStation?.cityName)
    ? isEmpty(originStation?.stationName)
      ? originStation?.code
      : originStation?.stationName
    : originStation?.cityName;
  let toCityName = isEmpty(destinationStation?.cityName)
    ? isEmpty(destinationStation?.stationName)
      ? destinationStation?.code
      : destinationStation?.stationName
    : destinationStation?.cityName;
  fromCityName = fromCityName?.replace(/- all stations/i, '');
  toCityName = toCityName?.replace(/- all stations/i, '');

  if (isEmpty(response?.paymentInfo)) {
    try {
      const checkoutApiRequest = {
        mmtId: response?.mmtId,
      };

      if (!isNull(bnppResponseOnReview) && bnppShownOnReview) {
        checkoutApiRequest.reviewAddOns = {
          bnpp:{
            bnppOpted: isBnppOpted,
            bnppShown: bnppShownOnReview,
            bnppShownVariant: getSeatLockReviewVariants(),
            bnppEligible: getIfCanShowBNPP() && !isEmpty(bnppResponseTravelerPage),
          }
        }
      }
      dispatch(showPageLoaderAction());
      let checkoutData = await bookingCheckoutAPIForPaymentInfo(checkoutApiRequest);
  
      if (checkoutData?.success) {
        response.paymentInfo = checkoutData?.paymentInfo;
      } else if (checkoutData?.errorDetails) {
        return dispatch(reviewStatus(checkoutData));
      }
    } catch(err) {
      return dispatch(reviewStatus());
    } finally {
      dispatch(hidePageLoaderAction());
    }
  }

  const {
    frmStnCode: fromCityStnCode,
    toStnCode: toCityStnCode,
    frmStnName: fromCityStnName,
    toStnName: toCityStnName,
    trainName,
    trainNumber,
    arrivalDateAndTime,
    departureDateAndTime,
  } = selectedTrainInfo;

  const numberOfPassengers = selectedTravelers?.length;
  const commonData = `${trainName}|${trainNumber}|${selectedQuota?.code}|${classValue?.code}|${currentAvailabilityStatus}|${numberOfPassengers}`;
  trackTravellerSeatInfo(REVIEW_PAGE_TRACKING_KEY,commonData);

  let paxCount = {
    adult: 0,
    child: 0
  };
  const travelerIdMap = {};
  travelers.forEach((trv) => {
    travelerIdMap[trv.travelerId] = trv;
  });
  const selectedTravelersObj = compact(selectedTravelers.map(trvId => travelerIdMap[trvId]));
  forEach(selectedTravelersObj, (trv) => {
    if (isAdult(trv)) {
      paxCount = {
        ...paxCount,
        adult: paxCount.adult + 1
      };
    } else {
      paxCount = {
        ...paxCount,
        child: paxCount.child + 1
      };
    }
  });

  const passengerCountObject = paxCount;

  const getDateTime = (dateObj) => {
    const date = fecha.format(dateObj, 'DD MMM');
    const time = fecha.format(dateObj, 'h:mm A');// 'HH:mm');
    return {
      date,
      time
    };
  };
  let travelerList = [];

  travelerList = request.passengerList.map((pax) => {
    const {
      passengerName: name,
      passengerGender: gender,
      passengerAge: age,
      passengerFoodChoice: foodChoice,
      passengerBerthChoice: berthChoice,
      concessionOpted
    } = pax;
    const rightSectionTxts = [];
    if (!isEmpty(foodChoice)) {
      rightSectionTxts.push(_label(getMealObject(foodChoice, applicableFoodTypes)?.value));
    }
    if (!isEmpty(berthChoice) && berthChoice !== "NONE") {
      rightSectionTxts.push(_label(getBerthType(berthChoice).value));
    }
    if (concessionOpted) {
      rightSectionTxts.push(_label("sr_ctzn_concession_applied"));
    }
    return {
      name,
      mainText: `${name}, ${age} yrs, ${_label(getGenderfromValue(gender).displayText)}`,
      extraText: rightSectionTxts.join(', ')
    };
  });

  const {date: departureDate, time: departureTime} = getDateTime(departureDateAndTime);
  const {date: arrivalDate, time: arrivalTime} = getDateTime(arrivalDateAndTime);
  paxCount = _label('adult_cta', { capitalize: true }, { label: passengerCountObject.adult });
  if (passengerCountObject.child > 0) {
    paxCount += `, ${_label(
      'child_cta',
      { capitalize: true },
      { label: passengerCountObject.child },
    )}`;
  }
  const classInfo = _label(classValue?.value);
  // const quotaInfo = `${selectedQuota.code} - ${selectedQuota.value}`;
  const quotaInfo = ` ${_label(selectedQuota?.text)}`;

  let boardingStationCode, boardingStation, boardingDay, boardingTime;
  if(selectedPickupStation){
    boardingStationCode = selectedPickupStation.stationCode;
    boardingStation = selectedPickupStation.stationName;
    boardingDay = selectedPickupStation.date;
    boardingTime = selectedPickupStation.departureTime;
  }
  else{
    boardingStationCode = fromCityStnCode;
    boardingStation = fromCityStnName;
    boardingDay = fecha.format(addDays(selectedTrainInfo.departureDateAndTime, 0), 'D MMM');
    boardingTime = fecha.format(fecha.parse(selectedTrainInfo.departureTime, 'HH:mm'), 'h:mm A');
  }


  const availability = response.avlDayList[0];

  const formatDuration = (minutes) => {
    const hr = Math.floor(minutes / 60);
    const min = minutes % 60;
    if (min > 0) {
      return `${hr}h ${min}m`;
    }
    return `${hr}h`;
  };

  const updatedReservationValue = getReservationChoice(selectedReservationChoice, confirmBookCheckbox) || {};
  const selectedReservationChoiceUpdated = getRsChoiceByValue(updatedReservationValue) || {};
  let reservationChoiceValue = '';
  if (updatedReservationValue !== NO_RESERVATION_CHOICE_CODE) {
    reservationChoiceValue = getRsChoiceByValue(selectedReservationChoiceUpdated.value).key;
  }

  const bookingSummaryInfo = {
    fromCityName,
    fromCityStnName,
    fromCityStnCode,
    toCityName,
    toCityStnName,
    toCityStnCode,
    trainName,
    trainNumber,
    departureDate,
    departureTime,
    arrivalDate,
    arrivalTime,
    paxCount,
    classInfo,
    quotaInfo,
    selectedReservationChoice: {
      ...selectedReservationChoiceUpdated,
      value: reservationChoiceValue
    },
    boardingStationCode,
    boardingStation,
    boardingDay,
    boardingTime,
    duration: formatDuration(selectedTrainInfo?.duration || 0),
    travelerList,
    availablityStatus: availability.availablityStatus,
    availablityType: availability.availablityType,
    availablityColorCode: (availabilityTypeColors[availability.availablityType] || '#000000'),
    isAvailablityTypeChanged: !(
      selectedBookingDate?.availablityType === availability?.availablityType
    ),
  };

  // response.paymentFareBreakup = getPaymentFareDetails(response);
  // const backBehaviourConfig = {
  //   title: 'Do you want to go back?',
  //   message: 'Seats are filling fast! Seat availability may change if you go back.',
  //   exit_text: 'GO BACK',
  //   continue_text: 'CONTINUE BOOKING'
  // };

  const paymentPageData = {
    lob: 'RAILS', // DO NOT CHANGE THIS
    request,
    response,
    bookingSummaryInfo,
    backBehaviourConfig: undefined
  };
  //skywalker start
  try{
    const skyWalkerData = {
      fromCity: bookingSummaryInfo?.fromCityStnCode,
      toCity: bookingSummaryInfo?.toCityStnCode,
      trainNumber: bookingSummaryInfo?.trainNumber,
    }
    skywalkerSectorConnector(skyWalkerData, 'payment');
  }catch(e){
    console.log('Error in skywalker:', e)
  }
  //skywalker end

  // trackReviewPageEvent('mob_rail_review_continue');
  if (isIos()) {
    PaymentModule.openPaymentPage(paymentPageData, getRootTag());
  } else if (isMweb()) {
    window.location.href = response.paymentInfo.checkoutUrl;
  } else {
    PaymentModule.openPaymentPage(paymentPageData);
  }
};

export const availabilityTypeColors = {
  1: '#26B5A9',
  2: '#26B5A9',
  3: '#FF6F00',
  4: '#FF6F00'
};
